import locale from "localization/en";

export const columns = [
  { key: "email", text: locale.emailAddress, width: "250px" },
  { key: "statusDate", text: locale.status, width: "200px" },
  { key: "actions", text: locale.action, width: "100px" },
];
